module.exports = __webpack_public_path__ + "static/media/onyourmarks.487f0dd8.jpg";